<template>
  <forgerock-template id="passkey-pr-page">
    <stihl-section>

      <form @submit.prevent="save">

        <h1>{{ $t('SUI.page.passkeyPreRegister.title') }}</h1>
        <div class="form-text mt-4">
          {{ $t('SUI.page.passkeyPreRegister.generalInfo') }}
          <i class="bi bi-info-circle-fill action" @click="showPasskeyInfo = true" />
        </div>
        <div class="form-text mt-4 mb-4">{{ $t('SUI.page.passkeyPreRegister.dssInfo') }}</div>

        <div class="buttons">
          <button id="yes" type="button" class="btn btn-primary" @click="save">
            {{ $t('SUI.page.passkeyPreRegister.btnRegister') }}
          </button>
          <button id="no" type="button" class="btn btn-secondary" @click="skip">
            {{ $t('SUI.page.passkeyPreRegister.btnNotNow') }}
          </button>
          <button id="not_again" type="button" class="btn btn-default" @click="doNotAskAgain">
            {{ $t('SUI.page.passkeyPreRegister.btnDoNotAskAgain') }}
          </button>
          <help-menu/>
        </div>
      </form>

    </stihl-section>
  </forgerock-template>


  <stihl-modal class="modal modal-lg" @modal-closed="showPasskeyInfo=false" v-if="showPasskeyInfo">
    <div class="title-row">
      <h3 class="title" v-text="$t('SUI.page.passkeyPreRegister.about')"/>
    </div>
    <div class="modal-body-content">
      <p>{{ $t('SUI.page.passkeyPreRegister.info1') }}</p>
      <p>{{ $t('SUI.page.passkeyPreRegister.info2') }}</p>
      <p>{{ $t('SUI.page.passkeyPreRegister.info3') }}</p>
    </div>
  </stihl-modal>


</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StihlSection from '@/components/ui/StihlSection.vue';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';
import HelpMenu from '@/components/ui/HelpMenu.vue';
import StihlModal from '@/components/ui/StihlModal.vue';
import { fr } from '@/components/forgerock';
import { mapState } from 'pinia';
import { useLoginStore } from '@/components/login.store';
import { CallbackType } from '@forgerock/javascript-sdk';

export default defineComponent({
  name: 'PasskeyPreRegistrationPage',
  components: { StihlModal, HelpMenu, ForgerockTemplate, StihlSection, },

  data() {
    return {
      showPasskeyInfo: false
    };
  },
  computed: {
    ...mapState(useLoginStore, ['currentStep']),
  },
  methods: {
    save() {
      this.currentStep.getCallbackOfType(CallbackType.ChoiceCallback).setInputValue(0); // yes
      fr.submitStep(this.currentStep);
    },
    skip() {
      this.currentStep.getCallbackOfType(CallbackType.ChoiceCallback).setInputValue(1); // no
      fr.submitStep(this.currentStep);
    },
    doNotAskAgain() {
      this.currentStep.getCallbackOfType(CallbackType.ChoiceCallback).setInputValue(2); // no_and_dont_ask
      fr.submitStep(this.currentStep);
    }
  }
});
</script>

<style scoped>
.passkey-popover {
  max-width: 600px;
}
</style>
